import { motion } from "framer-motion";
import SectionHeading from "../../components/ui/SectionHeading";
import ScrollReveal from "../../components/animations/ScrollReveal";

const steps = [
  "We start by understanding your goals, audience, and market so every recommendation is aligned with your vision.",
  "We propose a tailored strategy and plan, with clear milestones and deliverables.",
  "We execute with precision—whether that's an event, a campaign, or a full digital presence—keeping you updated at every stage.",
  "We measure, learn, and refine so your investment continues to pay off.",
];

export default function ApproachPreview() {
  return (
    <section className="py-20 md:py-28 bg-aura-bg">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="Our Approach"
          title="How we work with you"
          subtitle="A clear, collaborative process designed to deliver results without the hassle."
        />
        <div className="mt-14 max-w-3xl mx-auto">
          <ul className="space-y-6">
            {steps.map((text, i) => (
              <ScrollReveal key={i} delay={i * 0.08}>
                <li className="flex gap-4">
                  <span className="flex-shrink-0 w-8 h-8 rounded-full bg-gold-primary/20 text-gold-dark font-sans text-sm font-semibold flex items-center justify-center">
                    {i + 1}
                  </span>
                  <p className="font-sans text-aura-text leading-relaxed pt-0.5">
                    {text}
                  </p>
                </li>
              </ScrollReveal>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
